// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.00057 3.99951V1.99951H7.00057V3.99951H5.43437L1.23438 10.9995H22.7668L18.5668 3.99951H9.00057Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 12.9995H3V21.9995H8.50098V16H15.501V21.9995H21V12.9995Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.501 18V22H13.501V18H10.501Z"}}]};

const Houses2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'houses-2-filled',
    ref,
    icon: element,
  },
));

Houses2FilledIcon.displayName = 'Houses2FilledIcon';

export default Houses2FilledIcon;
